import React, { useRef, useEffect } from 'react';
import { track } from '../modules/tracking';
import PropTypes from 'prop-types';
import { ALLERGEN_ALERT, APPLY, CLOSE } from '../modules/constants';

import { AllergenFilter } from './allergenfilter';
import { DietFilter } from './dietfilter';
import { CaloriesToggle } from './caloriestoggle';

const COMPONENT_CLASS_NAME = 'filter';
const BLOCK_CLASS = 'block';

function resetForm(form) {
    [].forEach.call(form.querySelectorAll('[type="checkbox"]'), (chk) => {
        chk.checked = false;
    });
}

/**
 * Parent filter component.
 *
 * @function
 * @param       {object} props filter props.
 * @constructor
 */
function Filter(props) {
    const {
        allergenFilter,
        dietFilter,
        filterCount,
        hideCalories,
        setHideCalories,
        setAllergenFilter,
        setDietFilter,
        setFilterCount,
        setShowFilter,
        showFilter
    } = props;

    const allergenCount = Object.entries(allergenFilter).filter(
        ([key, value]) => key !== 'HIDETRACES' && value === true
    ).length;
    const dietCount = dietFilter.length;
    const showClear = allergenCount > 0 || dietCount > 0 || hideCalories;

    const form1 = useRef(null);
    const form2 = useRef(null);
    const form3 = useRef(null);

    function clearForm() {
        setAllergenFilter({ HIDETRACES: true });
        setDietFilter([]);
        setHideCalories(false);
        resetForm(form1.current);
        resetForm(form2.current);
        resetForm(form3.current);
    }

    useEffect(() => {
        if (!isNaN(allergenCount) || !isNaN(dietCount) || hideCalories) {
            let count = allergenCount + dietCount;
            if (hideCalories) count++;

            if (count !== filterCount) {
                setFilterCount(count);
            }
        }
    }, [dietCount, allergenCount, hideCalories]);

    const allergenProps = {
        ref: form1,
        ...props
    };

    const dietProps = {
        ref: form2,
        ...props
    };

    const caloriesProps = {
        ref: form3,
        ...props
    };

    if (!showFilter) {
        return null;
    }

    return (
        <div className={COMPONENT_CLASS_NAME}>
            <div className='inner'>
                <a
                    className='close'
                    href='#close'
                    onClick={(e) => {
                        e.preventDefault();
                        setShowFilter(false);
                        track('Filters: Click: Close button: close filters')();
                    }}
                >
                    {CLOSE}
                </a>
                <div className='tabs'>
                    {allergenCount > 0 && (
                        <div className='alert'>
                            <p>{ALLERGEN_ALERT}</p>
                        </div>
                    )}
                    <DietFilter {...dietProps} blockClass={BLOCK_CLASS} />
                    <AllergenFilter {...allergenProps} />
                    <CaloriesToggle
                        {...caloriesProps}
                        blockClass={BLOCK_CLASS}
                    />
                    {showClear && (
                        <a
                            className='clear'
                            href='#no'
                            onClick={(e) => {
                                e.preventDefault();
                                clearForm(e.target);
                                track('Filters: Click: clear filters')();
                            }}
                        >
                            clear all
                        </a>
                    )}
                    <button
                        className='mobile cta'
                        onClick={() => {
                            setShowFilter(false);
                            track('Filters: Click: Apply filters button')();
                        }}
                    >
                        {APPLY}
                    </button>
                </div>
            </div>
        </div>
    );
}

Filter.propTypes = {
    allergenFilter: PropTypes.object,
    dietFilter: PropTypes.array,
    filterCount: PropTypes.number,
    hideCalories: PropTypes.bool,
    setHideCalories: PropTypes.func,
    setAllergenFilter: PropTypes.func,
    setDietFilter: PropTypes.func,
    setFilterCount: PropTypes.func,
    setShowFilter: PropTypes.func,
    showFilter: PropTypes.bool
};

export { Filter };
